import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check, Crown } from "lucide-react";
import { WordHeading } from "./_shared";

export default function FinalCtaSection() {
  return (
    <section
      id="pricing"
      className="dark-island py-28 lg:py-32 border-t border-white/10 relative overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#6B9BFF]/5 to-transparent" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 border border-[#6B9BFF]/30 bg-[#6B9BFF]/5 px-3 py-1.5 mb-8">
          <Crown className="w-3.5 h-3.5 text-[#6B9BFF]" />
          <span className="label-eyebrow text-[#6B9BFF]">Free to start</span>
        </div>
        <WordHeading
          headingClass="font-display text-5xl sm:text-7xl leading-[0.9] mb-6 tracking-tight"
          tokens={[
            { w: "Your" },
            { w: "transformation", mr: "0" },
            { br: true },
            { w: "starts", className: "text-[#6B9BFF]" },
            { w: "today.", className: "text-[#6B9BFF]", mr: "0" },
          ]}
        />
        <p className="text-white/70 mb-10 max-w-xl mx-auto text-base">
          One app. AI coach. No credit card required. Build your first plan in under 60 seconds.
        </p>
        <Link
          to="/auth?mode=signup"
          className="bg-[#6B9BFF] text-black font-black uppercase tracking-widest px-10 py-5 hover:bg-white transition-colors inline-flex items-center gap-2"
          data-testid="cta-bottom-button"
        >
          Create my account <ArrowRight className="w-4 h-4" />
        </Link>
        <div className="mt-6 text-xs text-white/40 inline-flex items-center gap-4 flex-wrap justify-center">
          <span className="inline-flex items-center gap-1.5"><Check className="w-3 h-3 text-[#6B9BFF]" /> No credit card</span>
          <span className="inline-flex items-center gap-1.5"><Check className="w-3 h-3 text-[#6B9BFF]" /> Cancel anytime</span>
          <span className="inline-flex items-center gap-1.5"><Check className="w-3 h-3 text-[#6B9BFF]" /> 60-second setup</span>
        </div>
      </div>
    </section>
  );
}
